<template>
  <div class="flex h-screen bg-gray-100">
    <aside class="nav-container w-64 bg-blue-900 text-white flex flex-col p-4 space-y-8">
      <div class="flex items-center">
        <img src="/image/im8.png" alt="Logo HotelBook" class="h-16 w-16 mr-2">
        <h1 class="text-1xl font-bold font-serif">AdminGate</h1>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im34.png" class="h-6 w-6 mr-2">
        <router-link to="/dash" class="hover:bg-blue-900 p-2 rounded transition">Dashboard</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im36.png" class="h-6 w-6 mr-2">
        <router-link to="/student" class="hover:bg-blue-900 p-2 rounded transition">Étudiants</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/icour.png" class="h-6 w-6 mr-2">
        <router-link to="/study" class="hover:bg-blue-900 p-2 rounded transition">Cours</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im35.png" class="h-6 w-6 mr-2">
        <router-link to="/event" class="hover:bg-blue-900 p-2 rounded transition">Calendrier</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im33.png" class="h-6 w-6 mr-2">
        <router-link to="/note" class="hover:bg-blue-900 p-2 rounded transition">Évaluations</router-link>
      </div>

      <div class="flex items-center font-serif">
        <img src="/image/im38.png" class="h-6 w-6 mr-2">
        <router-link to="/" class="hover:bg-blue-900 p-2 rounded transition">Logout</router-link>
      </div>
    </aside>



    <main class="flex-1 p-6 overflow-y-auto bg-white">
      <div class="max-w-4xl mx-auto space-y-8 font-serif">
        <div>
          <div class="flex justify-center font-serif">
            <img src="/image/cour.png" class="h-8 w-8 mr-2" />
            <h2 class="text-3xl text-blue-900 mb-4">Gestion des cours</h2>
          </div>

          <h2 class="text-1xl font-bold mb-4">Ajouter / Modifier un cours</h2>
          <form @submit.prevent="isEditing ? modifierCours() : ajouterCours()" enctype="multipart/form-data" class="grid grid-cols-2 gap-4 p-6 rounded shadow">
            <input v-model="form.title" placeholder="Titre" required class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none" />
            <input v-model="form.prof" placeholder="Professeur" required class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none" />
            <input v-model="form.description" placeholder="Description" required class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none" />
            <input v-model="form.semester" placeholder="Semestre" required class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none" />
            <input v-model="form.video_url" placeholder="URL vidéo" type="url" class="border p-2 rounded border-b-2 border-gray-300 bg-transparent focus:outline-none" />

            <div class="col-span-2 flex items-center space-x-2">
              <label class="font-medium">Fichier (PDF, max 50Mo) :</label>
              <input type="file" @change="handleFile" accept=".pdf" />
            </div>

            <div class="col-span-2 flex items-center space-x-2">
              <label class="font-medium">Image (max 2Mo) :</label>
              <input type="file" @change="handleImage" accept="image/*" />
            </div>

            <div class="col-span-2 flex justify-center">
              <button type="submit" class="w-[100px] h-8 bg-blue-900 text-white rounded hover:bg-blue-800 transition duration-300">
                {{ isEditing ? "Modifier" : "Ajouter" }}
              </button>
              <button v-if="isEditing" type="button" @click="annulerModification" class="ml-4 w-[100px] h-8 bg-gray-500 text-white rounded hover:bg-gray-600 transition duration-300">
                Annuler
              </button>
            </div>
          </form>
        </div>

        <div>
          <h2 class="text-1xl font-bold mb-4">Liste des cours</h2>

          <table class="min-w-full bg-white rounded shadow font-serif">
            <thead>
              <tr class="bg-blue-900 text-white text-left">
                <th class="py-2 px-4">Titre</th>
                <th class="py-2 px-4">Professeur</th>
                <th class="py-2 px-4">Description</th>
                <th class="py-2 px-4">Semestre</th>
                <th class="py-2 px-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="cours in coursList" :key="cours.id" class="border-b">
                <td class="py-2 px-4">{{ cours.title }}</td>
                <td class="py-2 px-4">{{ cours.prof }}</td>
                <td class="py-2 px-4 text-xs">{{ cours.description }}</td>
                <td class="py-2 px-4">{{ cours.semester }}</td>
               
                <td class="py-4 px-4 flex space-x-2">
                  <button @click="editerCours(cours)">
                    <img src="/image/im40.png" alt="Modifier" class="w-5 h-5 hover:scale-110 transition" />
                  </button>
                  <button @click="supprimerCours(cours.id)">
                    <img src="/image/im41.png" alt="Supprimer" class="w-5 h-5 hover:scale-110 transition" />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>


        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'StudyView',
  data() {
    return {
      form: {
        id: null,
        title: '',
        prof: '',
        description: '',
        semester: '',
        video_url: '',
        file: null,
        image: null,
      },
      coursList: [],
      isEditing: false,
    }
  },
  mounted() {
    this.getCours()
  },
  methods: {
    getCours() {
      axios.get('https://mida-back.onrender.com/api/courses')
        .then(response => {
          this.coursList = response.data
        })
        .catch(err => console.error('Erreur récupération cours', err))
    },

    handleFile(event) {
      this.form.file = event.target.files[0]
    },

    handleImage(event) {
      this.form.image = event.target.files[0]
    },

    ajouterCours() {
      // Vérification simple avant envoi
      if (!this.form.title || !this.form.prof || !this.form.description || !this.form.semester) {
        alert("Veuillez remplir tous les champs obligatoires.")
        return
      }

      const formData = new FormData()
      formData.append('title', this.form.title)
      formData.append('prof', this.form.prof)
      formData.append('description', this.form.description)
      formData.append('semester', this.form.semester)
      formData.append('video_url', this.form.video_url)
      if (this.form.file) formData.append('file_path', this.form.file)
      if (this.form.image) formData.append('image', this.form.image)

      axios.post('https://mida-back.onrender.com/api/courses', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
        .then(() => {
          alert('Cours ajouté avec succès !')
          this.reinitialiserForm()
          this.getCours()
        })
        .catch(error => {
          alert('Erreur lors de l\'ajout du cours')
          console.error(error.response.data)
        })
    },

    editerCours(cours) {
      this.isEditing = true
      this.form = { ...cours, file: null, image: null }
    },

    modifierCours() {
      if (!this.form.title || !this.form.prof || !this.form.description || !this.form.semester) {
        alert("Veuillez remplir tous les champs obligatoires.")
        return
      }

      if (!confirm("Voulez-vous vraiment modifier ce cours ?")) return

      const formData = new FormData()
      formData.append('title', this.form.title)
      formData.append('prof', this.form.prof)
      formData.append('description', this.form.description)
      formData.append('semester', this.form.semester)
      formData.append('video_url', this.form.video_url)
      if (this.form.file) formData.append('file_path', this.form.file)
      if (this.form.image) formData.append('image', this.form.image)
      formData.append('_method', 'PUT') 

      axios.post(`https://mida-back.onrender.com/api/courses/${this.form.id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
        .then(() => {
          alert('Cours modifié avec succès !')
          this.reinitialiserForm()
          this.getCours()
          this.isEditing = false
        })
        .catch(error => {
          alert('Erreur lors de la modification du cours')
          console.error(error.response.data)
        })
    },

    supprimerCours(id) {
      if (!confirm("Voulez-vous vraiment supprimer ce cours ?")) return

      axios.delete(`https://mida-back.onrender.com/api/courses/${id}`)
        .then(() => {
          alert('Cours supprimé avec succès !')
          this.coursList = this.coursList.filter(c => c.id !== id)
        })
        .catch(error => {
          alert('Erreur lors de la suppression du cours')
          console.error(error.response.data)
        })
    },

    annulerModification() {
      this.isEditing = false
      this.reinitialiserForm()
    },

    reinitialiserForm() {
      this.form = {
        id: null,
        title: '',
        prof: '',
        description: '',
        semester: '',
        video_url: '',
        file: null,
        image: null,
      }
      
    },
  }
}
</script>

<style scoped>
.nav-container {
  background-color: #163767;
}

.container {
  max-width: 800px;
  margin: auto;
}
input, select {
  display: block;
  margin: 5px 0;
  padding: 8px;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}
th, td {
  border: 1px solid #ddd;
  padding: 8px;
}
</style>
